import { useMemo, useState } from "react";

import SearchInput from "components/SearchInput";

import { useTranslationContext } from "context/TranslationContext";

interface ActionWrapperProps {
  children?: React.ReactNode;
  keyword?: string;
  onSearch?: (keyword: string) => void;
}

const ActionWrapper = ({ children, keyword, onSearch }: ActionWrapperProps) => {
  const { t } = useTranslationContext();
  const [expandSearch, setExpandSearch] = useState(false);

  const openSearch = useMemo(() => {
    return expandSearch || !!keyword;
  }, [expandSearch, keyword]);

  const handleExpandSearch = () => {
    setExpandSearch(true);
  };

  const handleSearch = (keyword: string) => {
    onSearch?.(keyword);
  };

  const handleClearSearch = () => {
    setExpandSearch(false);
    handleSearch("");
  };

  return (
    <div className="flex items-center justify-end gap-2">
      <SearchInput
        debounceTime={300}
        withDebounce
        className={openSearch ? undefined : "w-[2.7rem]"}
        keepClearIcon={openSearch}
        placeholder={t("enter_keyword")}
        defaultValue={keyword}
        onClickLeftIcon={handleExpandSearch}
        onClearSearch={handleClearSearch}
        onSearch={handleSearch}
      />
      {children}
    </div>
  );
};

export default ActionWrapper;
